var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative mb-6 overflow-hidden"},[_c('div',{staticClass:"pointer-events-none absolute inset-0 border-b border-slate-200"}),_c('nav',{staticClass:"relative top-0 -mx-20 flex gap-x-4 px-20",attrs:{"aria-label":"Tabs"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }